import { createTheme, ThemeProvider } from '@mui/material';
import { deepmerge } from '@mui/utils';
import { useRecoilValue } from 'recoil';
import { accountCompanyInfoAtom } from '../models/atoms/account_atoms';
import { defaultTheme } from '../views/themes/defaultTheme';
import { oldcastleTheme } from '../views/themes/oldcastleTheme';
import { aclaraTheme } from '../views/themes/aclaraTheme';
import { highTideTheme } from '../views/themes/highTideTheme';
import { macSepticTheme } from '../views/themes/macSepticTheme';
import { beadedStreamTheme } from '../views/themes/beadedStreamTheme';

export function MHMThemeProvider({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element {
  const companyInfo = useRecoilValue(accountCompanyInfoAtom);
  let theme = defaultTheme;

  if (!window.location.pathname.includes('/battery_life')) {
    const subdomain = window.location.hostname.split('.')[0];
    switch (companyInfo?.theme ?? subdomain) {
      case 'oldcastle':
        theme = oldcastleTheme;
        break;
      case 'aclara':
        theme = aclaraTheme;
        break;
      case 'htt':
        theme = highTideTheme;
        break;
      case 'macseptic':
        theme = macSepticTheme;
        break;
      case 'beadedstream':
        theme = beadedStreamTheme;
        break;
      default:
        theme = defaultTheme;
    }
  }

  const themeObject = createTheme(deepmerge(defaultTheme, theme));

  return <ThemeProvider theme={themeObject}>{children}</ThemeProvider>;
}
